import { makeStyles, styled } from '@material-ui/core/styles'

export const Logo = styled('div')(({ theme, image, embedview }) => ({
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${image}?h=150&w=150&fit=fill&fl=progressive&q=80)`,
  width: '72px',
  height: '72px',
  marginRight: embedview ? '0px' : theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    width: '54px',
    height: '54px',
    backgroundImage: `url(${image}?h=110&w=110&fit=fill&fl=progressive&q=80)`,
    marginRight: embedview ? '0px' : theme.spacing(2),
  },
}))

const useStyles = makeStyles(theme => ({
  root: ({ isEmbedView }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.primary.contrastText,
    color: theme.palette.secondary.main,
    border: isEmbedView ? 'none' : '1px solid #00234B',
    borderRadius: isEmbedView ? '0px' : '4px',
    padding: isEmbedView ? '8px 0px' : '8px 24px',
    height: '100px',
    '&:hover': {
      backgroundColor: 'rgba(250, 250, 250, 0.95)',
    },
    '& .MuiDivider-vertical': {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: isEmbedView ? '8px 0px' : '8px 8px',
      height: '70px',
      '& .MuiDivider-vertical': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
      },
    },
  }),
  description: ({ isEmbedView }) => ({
    marginRight: theme.spacing(7),
    '& h6': {
      textTransform: 'uppercase',
      fontFamily: 'Nunito Sans',
      color: isEmbedView ? theme.palette.ryderCup.usa : 'inherit',
      '&:first-child': {
        marginBottom: theme.spacing(1),
      },
      '&:last-child': {
        color: isEmbedView ? theme.palette.ryderCup.neutral : theme.palette.secondary.light,
        textTransform: isEmbedView ? 'none' : 'uppercase',
        fontSize: isEmbedView ? '12px' : 'initial',
        lineHeight: isEmbedView ? '8px' : 'initial',
      },
    },
    [theme.breakpoints.down('sm')]: {
      '& h6': {
        fontSize: '16px',
        fontWeight: '700',
        '&:first-child': {
          marginBottom: isEmbedView ? theme.spacing(1) : '0px !important',
        },
        '&:last-child': {
          display: isEmbedView ? 'block' : 'none',
        },
      },
      marginRight: theme.spacing(1),
    },
  }),
  link: ({ isEmbedView }) => ({
    position: isEmbedView ? 'fixed' : 'unset',
    bottom: 0,
    borderTop: isEmbedView ? '1px solid #AFAFAF' : 'unset',
    borderBottom: isEmbedView ? '1px solid #CCCCCC' : 'unset',
    marginTop: theme.spacing(4),
    marginBottom: isEmbedView ? '0px' : theme.spacing(10),
    width: isEmbedView ? '100%' : 'unset',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: isEmbedView ? '0px' : theme.spacing(2),
      paddingRight: isEmbedView ? '0px' : theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: isEmbedView ? '0px' : theme.spacing(6),
    },
  }),
  cta: {
    width: '34px',
    '&:after, &:before': {
      width: 12,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

export default useStyles
